interface PageWrapperProps {
  children: React.ReactNode;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  className?: string;
}

export const PageWrapper = ({ children, padding = 'md', className = '' }: PageWrapperProps) => {
  const paddingClasses = {
    none: '',
    sm: 'p-2',
    md: 'p-4',
    lg: 'p-6',
  };

  return <div className={`h-full ${paddingClasses[padding]} ${className}`}>{children}</div>;
};
